import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import FileIcon from '@wix/da-ds/pkg/Icons/24x24/File';

import s from './ReplaceSourceFileButton.scss';

export interface ReplaceSourceFileButtonProps {
  className?: string;
  inputOrig: React.ReactNode;
  allowUpload: boolean;
  showOrigFilePicker: () => void;
}

const ReplaceSourceFileButton: React.FC<ReplaceSourceFileButtonProps> = ({
  className,
  inputOrig,
  allowUpload,
  showOrigFilePicker,
}) => {
  const { t } = useTranslation();
  const tooltip = t('deviationSubmit.form.original.replace.tooltip.text');

  return (
    <>
      {inputOrig}
      <div className={className}>
        <IconButton
          className={cn(s['edit-btn'], !allowUpload && s['disabled'])}
          size={'small'}
          icon={FileIcon}
          disabled={!allowUpload}
          onClick={allowUpload ? showOrigFilePicker : undefined}
          tooltipOffset={[0, 8]}
          tooltipText={tooltip}
          aria-label={tooltip}
        />
      </div>
    </>
  );
};
ReplaceSourceFileButton.displayName = 'ReplaceSourceFileButton';

export default ReplaceSourceFileButton;
